import { render, staticRenderFns } from "./hsCodeSearchDialog.vue?vue&type=template&id=20ef07dd&scoped=true&"
import script from "./hsCodeSearchDialog.vue?vue&type=script&lang=js&"
export * from "./hsCodeSearchDialog.vue?vue&type=script&lang=js&"
import style0 from "./hsCodeSearchDialog.vue?vue&type=style&index=0&id=20ef07dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ef07dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20ef07dd')) {
      api.createRecord('20ef07dd', component.options)
    } else {
      api.reload('20ef07dd', component.options)
    }
    module.hot.accept("./hsCodeSearchDialog.vue?vue&type=template&id=20ef07dd&scoped=true&", function () {
      api.rerender('20ef07dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/hsCodeSearchDialog.vue"
export default component.exports